import moment from 'moment';

const ValidationRules = [
    {
        "required_field":
        {
            "not_null":
            {
                error: "This field is required and cannot be left empty."
            }
        },
        "required_true":
        {
            "not_true":
            {
                error: "You must agree in order to continue."
            }
        },
        "number_only":
        {
            "regex_check":
            {
                value: /^[0-9]*$/,
                error: "Please enter a valid number"
            }
        },
        "rent_amount":
        {
            "regex_check":
            {
                value: /^\d+(\.\d{1,2})?$/i,
                error: "Please enter a valid currency value"
            },
            "minimum":
            {
                value: 1,
                error: 'Rent amount must be greater than zero.'
            },
        },
        "tax_code": {
            "regex_check":
            {
                value: /^([a-zA-Z0-9]{1,8})$/,
                error: 'Tax codes must be alphanumeric'
            }
        },
        "2_decimal_money":
        {
            "regex_check":
            {
                value: /^\d+(\.\d{1,2})?$/i,
                error: "Please enter a valid currency value"
            }
        },
        "tenancy_start":
        {
            "not_null":
            {
                error: "Please enter a policy start date",
            },
        },
        "date_of_birth_at":
        {
            "too_young":
            {
                value: moment().subtract(18, 'years'),
                error: 'You must be at least 18 years old to register as a tenant',
            },
            "too_old":
            {
                value: moment().subtract(115, 'years'),
                error: 'Your date of birth cannot be more than 115 years ago',
            },
        },
        "end_date":
        {
            "too_soon":
            {
                error: "The end date cannot be in the past",
            },
        },
        "six_month_income_change":
        {
            "not_null":
            {
                error: "A date is required",
            },
            "too_soon":
            {
                error: "The date cannot be in the past",
            }
        },
        "current_employer":
        {
            "not_null":
            {
                error: "Please provide the start date for your current employment."
            },
            "no_future_dates":
            {
                value: moment().add(1, 'days'),
                error: 'The start date for your current employment cannot be in the future.'
            }
        },
        "email_address":
        {
            "regex_check":
            {
                // Must contain an @ symbol with a string or integer value before and after it.
                // Must also have a period after the string following the @ symbol that also has something following it.
                // To test: http://regexr.com/
                value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                error: 'Please enter a valid email address',
            }
        },
        "postcode":
        {
            "regex_check":
            {
                value: /^[A-Z]{1,2}[0-9R][0-9A-Z]? ?[0-9][ABD-HJLNP-UW-Z]{2}$/,
                error: 'Please enter a valid postcode'
            }
        },
        "phone_number":
        {
            "minimum":
            {
                value: 7,
                error: 'Phone number is a minimum of 7 digits'
            },
            "maximum":
            {
                value: 20,
                error: 'Phone number is a maximum of 20 digits.'
            },
            "regex_check":
            {
                value: /^[+{0,1}]\d+$/,
                error: 'Please enter only numbers'
            }
        },
        "phone_number_eleven":
        {
            "minimum":
            {
                value: 7,
                error: 'Phone number is a minimum of 7 digits'
            },
            "maximum":
            {
                value: 11,
                error: 'Phone number is a maximum of 11 digits.'
            },
            "regex_check":
            {
                value: /^[+{0,1}]\d+$/,
                error: 'Please enter only numbers'
            }
        },
        "mobile_number":
        {
            "regex_check":
            {
                value: /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/,
                error: 'Please enter a valid UK mobile number',
            }
        },
        "alpha_and_space_only":
        {
            "regex_check":
            {
                value: /^[a-z\d\-_\s]+$/i,
                error: 'Please only enter alphanumeric characters and spaces'
            }
        },
        "sortcode":
        {
            "regex_check":
            {
                value: /^(\d){6}$/,
                error: 'Sort code must be 6 digits in length.',
            }
        },
        "bank_account":
        {
            "regex_check":
            {
                value: /^(\d){8}$/,
                error: 'Bank account numbers must be 8 digits in length.',
            }
        },
        "tenancy_term":
        {
            "minimum":
            {
                value: 1,
                error: 'Tenancy term must be at least 1 month.'
            },
            "maximum":
            {
                value: 60,
                error: 'Tenancy term cannot be more than 60 months.'
            }
        },
        "at_least_one":
        {
            "minimum":
            {
                value: 1,
                error: 'You must select at least one to continue.'
            }
        },
        "duration_months_date":
        {
            "not_null":
            {
                error: "Please provide a duration."
            }
        },
        "duration_months_tenancy":
        {
            "not_null":
            {
                error: "Please provide how long you lived at this address."
            },
            "minimum":
            {
                value: 1,
                error: 'The duration at the address must be at least 1 month.'
            }
        },
        "email_confirm":
        {
            "regex_check":
            {
                // Must contain an @ symbol with a string or integer value before and after it.
                // Must also have a period after the string following the @ symbol that also has something following it.
                // To test: http://regexr.com/
                value: /(.+)@(.+){2,}\.(.+){2,}/,
                error: 'Please enter a valid email address',
            },
            "match":
            {
                error: "Email addresses must match."
            }
        }
    },
];

export default ValidationRules;



// WEBPACK FOOTER //
// ./src/components/Data/ValidationRules.js